module.exports = __webpack_public_path__ + "static/image/history/m/202311@x3.jpg?63a02159";